module.exports = __webpack_public_path__ + "static/media/internet-light-gray.e0a16fd7.svg";